<template>
  <div class="area-index margin-l-20" >
    <div class="area-index-header margin-r-20 ">
<!--      <el-select v-model="value" placeholder="请选择" @change="getAll" class="margin-l-20">-->
<!--        <el-option v-for='item in typeList' :key="item.value" :label="item.value" :value="item.value" ></el-option>-->
<!--      </el-select>-->
      <el-date-picker class="margin-l-20" v-model="endTime" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" :picker-options="pickerOptions"
                      value-format="yyyy-MM" @change="getAll"></el-date-picker>

    </div>
<!--    &lt;!&ndash;九江市宏观数据 &ndash;&gt;-->
    <div class="block  margin-t-20" v-show="this.userInfo.username !== 'jkq_2026'">
      <el-card class="margin-b-20 text-left margin-r-20 area-total">
        <el-row class="margin-b-20 margin-r-20">
          <el-col :span="6">
            <div class="index-bg" style="background-color: #0AB1DE">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num ">{{Alltotal.money}}</div>
                <div class="index-span-p">当期网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.moneyYoy}}%
                  <i :class="[Alltotal.moneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-money.png" class="margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #EC897D">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.ljMoney}}</div>
                <div class="index-span-p">累计网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.ljMoneyYoy}}%
                  <i :class="[Alltotal.ljMoneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljmoney.png" class=" margin-t-20"/>
                </div>
              </div>

            </div>
          </el-col>
          <el-col :span="6" >
            <div class="index-bg" style="background-color: #8A9AF4" >
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.sales}}</div>
                <div class="index-span-p">当期网络零售量（万件）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.salesYoy}}%
                  <i :class="[Alltotal.salesYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-sales.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #7DA2E4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.ljSales}}</div>
                <div class="index-span-p">累计网络零售量（万件）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.ljSalesYoy}}%
                  <i :class="[Alltotal.ljSalesYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljsales.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="margin-t-10 margin-r-20">
          <el-col :span="6">
            <div class="index-bg" style="background-color: #D8C477">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.shopNum}}</div>
                <div class="index-span-p">电商店铺数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-shopNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #C68DD4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.companyNum}}</div>
                <div class="index-span-p">电商企业数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-companyNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="index-bg" style="background-color: #EAAF98">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.ljMoneyRank}}</div>
                <div class="index-span-p">累计网络零售额排名</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljrank.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <!--        </el-carousel-item>-->
      <!--      </el-carousel>-->

    </div>
    <div class="block  margin-t-20" v-show="this.userInfo.username == 'jkq_2026'">
      <el-card class="margin-b-20 text-left margin-r-20 area-total">
        <el-row class="margin-b-20 margin-r-20" :gutter="40">
          <el-col :span="12">
            <div class="index-bg" style="background-color: #0AB1DE">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num ">{{Alltotal.money}}</div>
                <div class="index-span-p">当期网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.moneyYoy}}%
                  <i :class="[Alltotal.moneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-money.png" class="margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="index-bg" style="background-color: #EC897D">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.ljMoney}}</div>
                <div class="index-span-p">累计网络零售额（万元）</div>
                <div class="index-span-yoy"> 同比{{Alltotal.ljMoneyYoy}}%
                  <i :class="[Alltotal.ljMoneyYoy >=0?'el-icon-top text-red font-weight':'el-icon-bottom text-green font-weight']"></i></div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-ljmoney.png" class=" margin-t-20"/>
                </div>
              </div>

            </div>
          </el-col>

        </el-row>
        <el-row class="margin-t-10 margin-r-20" :gutter="40">
          <el-col :span="12">
            <div class="index-bg" style="background-color: #D8C477">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.shopNum}}</div>
                <div class="index-span-p">电商店铺数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-shopNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="index-bg" style="background-color: #C68DD4">
              <div style="float: left;margin-left: 20px">
                <div class="area-index-num">{{Alltotal.companyNum}}</div>
                <div class="index-span-p">电商企业数（家）</div>
              </div>
              <div style="float: right">
                <div class="index-span-box">
                  <img src="../../assets/areaIndex-companyNum.png" class=" margin-t-20"/>
                </div>
              </div>
            </div>
          </el-col>

        </el-row>
      </el-card>

    </div>
    <!--趋势图、实物行业排行 -->
    <div class="margin-t-20" v-show="this.userInfo.username !== 'jkq_2026'">
      <el-row>
        <el-col :span="12" class="padding-r-20">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title">{{this.userInfo.district}}当期网络零售额变化趋势</span>
            </div>
            <div class="moneyContent" style="margin-bottom:8px ;margin-top:0 ">
              <div class="moneyContents">
                {{ this.trendAnalysis && this.trendAnalysis.length > 0 ? this.trendAnalysis[0].description : '' }}
              </div>
            </div>
            <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100" style="height: 553px"></chart>
          </el-card>
        </el-col>
        <el-col :span="12" class="padding-r-20 industryRank">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title " >实物行业排行</span>
            </div>
            <div class="moneyContent margin-t-10 margin-b-15">
              <div class="moneyContents">
                {{ this.industryAnalysis && this.industryAnalysis.length > 0 ? this.industryAnalysis[0].description : '' }}
              </div>
            </div>
            <el-table :data="industryTable" width="460px" height="550" stripe class="border-DEDEDE margin-b-15"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="60" align="center"></el-table-column>
              <el-table-column prop="category" label="行业名称" width="170" ></el-table-column>
              <el-table-column prop="money" label="网络零售额（万元）" width="120" align="center"></el-table-column>
              <el-table-column prop="moneyPro" label="占实物网零比重（%）" align="center">
                <template slot-scope="scope">
                  {{ scope.row.moneyPro || '--' }}
                </template>
              </el-table-column>
              <el-table-column prop="moneyYoy" label="累计同比（%）" align="center">
                <template slot-scope="scope">
                  {{ scope.row.moneyYoy || '--' }}
                </template>
              </el-table-column>
              <el-table-column prop="moneyMom" label="当期环比（%）" align="center">
                <template slot-scope="scope">
                  {{ scope.row.moneyMom || '--' }}
                </template>
              </el-table-column>

            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div >
    <!--经开区趋势图和表 -->
    <el-card class="margin-t-30  text-left margin-r-20 margin-b-40"  v-show="this.userInfo.username == 'jkq_2026'">
      <el-row>
        <el-col :span="13">
          <div class="index-header text-left">
            <span class="index-header-title">{{this.userInfo.district}}当期网络零售额变化趋势</span>
          </div>
          <div class="moneyContent margin-t-10" style="margin-bottom:8px" >
            <div class="moneyContents">
              {{ this.trendAnalysis && this.trendAnalysis.length > 0 ? this.trendAnalysis[0].description : '' }}
            </div>

          </div>
          <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100 margin-t-30" style="height: 500px"></chart>
        </el-col>
        <el-col :span="10" class="margin-l-30 margin-t-10">
          <el-table :data="moneySalesTable" stripe height="610" class="border-DEDEDE margin-t-30">
            <el-table-column prop="times" label="时间" align="center"></el-table-column>
            <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
            <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <!--重点企业列表 -->
    <el-card class=" margin-t-20 margin-r-20 margin-b-20">
      <div slot="header" class=" text-left">
        <span class="index-header-title">重点企业列表</span>
      </div>
      <el-table :data="companyList" width="480px" height="650px" stripe  class="border-DEDEDE"
                :default-sort="{prop: 'ljMoney', order: 'descending'}">
        <el-table-column type="index" label="排名" align="center" width="60" ></el-table-column>
        <el-table-column prop="companyName" label="企业名称" width="290"  align="center"></el-table-column>
        <!--        <el-table-column prop="comIndexShow" label="企业综合得分" width="120" align="center"></el-table-column>-->
        <el-table-column prop="operName" label="法定代表人" align="center"></el-table-column>
        <el-table-column prop="location" label="注册地址"   width="250" align="center"></el-table-column>
        <el-table-column prop="econKind" label="企业类型" width="190"align="center"></el-table-column>
        <el-table-column  prop="money" label="当期网络零售额（万元）" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.money || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="ljMoney" label="累计网络零售额（万元）"  width="150"align="center">
          <template slot-scope="scope">
            {{ scope.row.ljMoney || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="ljMoneyYoy" label="累计同比（%）" align="center">
          <template slot-scope="scope">
            {{ scope.row.ljMoneyYoy || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="moneyMom" label="当期环比（%）" align="center">
          <template slot-scope="scope">
            {{ scope.row.moneyMom || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="companyId" label="统一社会信用代码" width="185" align="center"></el-table-column>
      </el-table>
    </el-card>

  </div>
</template>
<script>
  export default {
    name: "CityIndex",
    props: ['parent_value'],
    data: function() {
      return {
        endTime: '',
        userInfo: { username: '', password: '', district: '' },
        orgOptions: {},
        Alltotal: {},
        trendAnalysis: [],
        industryAnalysis: [],
        patternOptions: {},
        typeOptions: {},
        platformOptions: {},
        personalShopTable: [],
        industryTable: [],
        companyShopTable: [],
        moneySalesTable: [],
        value: "",
        typeList: [
          {'value': '九江市'},{'value': '柴桑区'},{'value': '德安县'},{'value': '都昌县'},{'value': '共青城市'},
          {'value': '湖口县'},{'value': '濂溪区'},{'value': '庐山市'},{'value': '彭泽县'},{'value': '瑞昌市'},{'value': '武宁县'},
          {'value': '修水县'},{'value': '浔阳区'},{'value': '永修县'}
        ],
        goodsTable: [],
        companyOptions: [],
        goodsShopTable: [],
        goodsListTable: [],
        moneyOptions: {},
        categoryTable: [],
        platformComOptions: {},
        indexOptions: {},
        areaIndexList: [],
        zhishuDing: [],
        total: 100,
        currentPage: 1,
        pageSize: 1000,
        companyForm: {times: '', money: '全部', keyWord: '', sMoney: '', eMoney: '', district:''},
        companyList: [],
        pickerOptions: {
          disabledDate: function(time) {
            var nowDate = new Date();
            var day = nowDate.getDate();
            nowDate.setDate(1);
            if (day > 14) {
              if (nowDate.getMonth() == 0) {
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else {
                nowDate.setMonth(nowDate.getMonth() - 1);
              }
            } else {
              if (nowDate.getMonth() == 0) {
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else if (nowDate.getMonth() == 1) {
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear() - 1);
              } else {
                nowDate.setMonth(nowDate.getMonth() - 2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1);
            }
            return time > nowDate;
          }
        },

      };
    },
    mounted: function() {
      this.$emit('public_header', true);
      this.oneMonth();

      // 绑定this上下文，替换箭头函数
      // setTimeout(function() {
        this.getHomeList();
        this.getAreaIndex();
        this.getCompanyByInfo();
        this.getTrendAnalysis();
        this.getIndustryAnalysis();
      // }.bind(this), 200);
    },
    methods: {
      handleCurrentChange: function(currentPage) {
        this.currentPage = currentPage;
        this.getCompanyByInfo();
      },
      getAll: function() {
        this.getAreaIndex();
        this.getHomeList();
        this.getCompanyByInfo();
        this.getTrendAnalysis();
        this.getIndustryAnalysis();
      },
      tableDetail: function(row) {
        this.goToDetail(row.id);
      },

      // 核心：按账号匹配区县，无默认九江市
      getHomeList: function() {
        var userInfoStr = sessionStorage.getItem('userInfo');
        try {
          this.userInfo = userInfoStr ? JSON.parse(userInfoStr) : { username: '', district: '' };
        } catch (e) {
          console.error('userInfo 解析失败', e);
          this.userInfo = { username: '', district: '' };
        }

        // 账号-区县映射
        if (this.userInfo.username == 'wnx_2025') {
          this.userInfo.district = '武宁县';
        } else if (this.userInfo.username == 'xsx_2025') {
          this.userInfo.district = '修水县';
        } else if (this.userInfo.username == 'yyx_2025') {
          this.userInfo.district = '永修县';
        } else if (this.userInfo.username == 'dax_2025') {
          this.userInfo.district = '德安县';
        } else if (this.userInfo.username == 'dcx_2025') {
          this.userInfo.district = '都昌县';
        } else if (this.userInfo.username == 'hkx_2025') {
          this.userInfo.district = '湖口县';
        } else if (this.userInfo.username == 'pzx_2025') {
          this.userInfo.district = '彭泽县';
        } else if (this.userInfo.username == 'rcs_2025') {
          this.userInfo.district = '瑞昌市';
        } else if (this.userInfo.username == 'gqcs_2025') {
          this.userInfo.district = '共青城市';
        } else if (this.userInfo.username == 'lss_2025') {
          this.userInfo.district = '庐山市';
        } else if (this.userInfo.username == 'csq_2025') {
          this.userInfo.district = '柴桑区';
        } else if (this.userInfo.username == 'xyq_2025') {
          this.userInfo.district = '浔阳区';
        } else if (this.userInfo.username == 'lxq_2025') {
          this.userInfo.district = '濂溪区';
        } else if (this.userInfo.username == 'jkq_2026') {
          this.userInfo.district = '九江经济技术开发区';
        }

        // 无区县不请求接口
        if (!this.userInfo.district) {
          console.warn('当前登录账号未匹配到区县');
          return;
        }

        this.$http.get(this.header + '/qyjc/home', {
          params: {
            times: this.endTime || '',
            city: this.userInfo.district
          }
        }).then(function(res) {
          var response = res.data || {};
          if (response.code == 0) {
            this.personalShopTable = response.shopRank || [];
            this.industryTable = response.spdlRank || [];
            this.Alltotal = response.area_index || {};
            this.goodsTable = response.goods || [];
            this.goodsShopTable = response.shop || [];
            this.companyShopTable = response.companyShopRank || [];
            this.goodsListTable = response.goods || [];
            this.categoryTable = response.category || [];

            // 地图数据处理（替换forEach为for循环）
            var mapData = [];
            if (response.districtList && response.districtList.length) {
              for (var i = 0; i < response.districtList.length; i++) {
                var x = response.districtList[i];
                mapData.push({
                  name: x.city || '',
                  value: x.absoulte_value_pro || 0,
                  yoy: x.absoulte_value_yoy || 0
                });
              }
            }

            this.orgOptions = {
              title: { text: '九江市网络零售全景', left: 'left', textStyle: { color: '#313131', fontSize: 16 } },
              tooltip: {
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function(e) {
                  return e.name + '网络零售额<br/>同比：' + (e.data.yoy || 0) + '%<br/>占比：' + (e.value || 0) + '%';
                }
              },
              visualMap: {
                min: 0,
                max: 30,
                inRange: { color: ['rgba(218,228,258,1)','rgba(143,176,245,1)','rgba(106,88,196,1)'] }
              },
              series: [{
                type: 'map',
                mapType: 'JJ',
                data: mapData,
                label: { normal: { show: true } }
              }]
            };

            // 网络零售额走势（替换forEach为for循环）
            var moneyList = { xTime: [], yTotalMoney: [], simple: [] };
            if (response.wlxs && response.wlxs.length) {
              for (var j = 0; j < response.wlxs.length; j++) {
                var y = response.wlxs[j];
                moneyList.xTime.push(y.times || '');
                moneyList.yTotalMoney.push({ value: y.absoulte_value || 0, unit: '万元' });
                moneyList.simple.push({ value: y.absoulte_value_yoy || 0, unit: '%' });
              }
            }

            var MoneyMin1 = this.moneyCalMin(moneyList.yTotalMoney);
            var MoneyMin2 = this.moneyCalMin(moneyList.simple);
            var MoneyMax1 = this.moneyCalMax(moneyList.yTotalMoney);
            var MoneyMax2 = this.moneyCalMax(moneyList.simple);

            this.moneyOptions = {
              color: ['#7888ed', '#FB975B'],
              tooltip: {
                trigger: 'item',
                formatter: function(e) {
                  return e.name + e.seriesName + '<br/>' + (e.value || 0) + (e.data.unit || '');
                }
              },
              legend: {
                orient: 'horizontal',
                y: 'bottom',
                textStyle: { color: '#666' },
                data: ['当期网络零售额', '同比']
              },
              xAxis: { type: 'category', data: moneyList.xTime },
              yAxis: [
                { type: 'value', name: '万元', min: MoneyMin1, max: MoneyMax1, interval: (MoneyMax1 - MoneyMin1) / 5 },
                { type: 'value', name: '%', min: MoneyMin2, max: MoneyMax2, interval: (MoneyMax2 - MoneyMin2) / 5 }
              ],
              series: [
                { name: '当期网络零售额', type: 'bar', data: moneyList.yTotalMoney, barWidth: 20 },
                { name: '同比', type: 'line', yAxisIndex: 1, data: moneyList.simple }
              ]
            };

            // 替换扩展运算符...，兼容ES5
            this.moneySalesTable = [];
            if (response.wlxs && response.wlxs.length) {
              for (var k = response.wlxs.length - 1; k >= 0; k--) {
                this.moneySalesTable.push(response.wlxs[k]);
              }
            }
          }
        }.bind(this)).catch(function(err) {
          console.error('首页接口异常', err);
        });
      },

      // 重点企业列表
      getCompanyByInfo: function() {
        if (!this.userInfo.district || !this.endTime) return;

        this.$http.get(this.header + '/wlls/companyRank/list', {
          params: {
            times: this.endTime.replace(/-/g, ''),
            limit: '1000',
            page: '1',
            province: '江西省',
            city: '九江市',
            district: this.userInfo.district
          }
        }).then(function(res) {
          if (res.data.code == 0 && res.data.data && res.data.data.list) {
            this.companyList = res.data.data.list;
            this.total = res.data.data.totalCount;
          }
        }.bind(this));
      },

      // 区域指数（移除可选链?.）
      getAreaIndex: function() {
        this.$http.get(this.header + '/qyjc/areaIndex', {
          params: { times: this.endTime }
        }).then(function(res) {
          if (res.data.code == 0 && res.data.areaIndex) {
            // 替换forEach为for循环
            for (var i = 0; i < res.data.areaIndex.length; i++) {
              var y = res.data.areaIndex[i];
              y.symbolSize = y.level == 1 ? 60 : (y.level == 2 ? 50 : 40);
              y.draggable = y.level == 1;
            }
            this.areaIndexList = res.data.areaIndex;

            // 移除可选链?.，改为ES5兼容判断
            var zhishu = '';
            if (this.areaIndexList && this.areaIndexList.length > 0 && this.areaIndexList[0].value) {
              zhishu = this.areaIndexList[0].value.toString();
            }

            // 处理指数数字
            this.zhishuDing = [];
            for (var j = 0; j < zhishu.length; j++) {
              var c = zhishu.charAt(j);
              this.zhishuDing.push(isNaN(c) ? '.' : Number(c));
            }

            // 构建testList（替换forEach为for循环）
            var testList = [];
            for (var k = 0; k < this.areaIndexList.length; k++) {
              var x = this.areaIndexList[k];
              for (var l = 0; l < this.areaIndexList.length; l++) {
                var yItem = this.areaIndexList[l];
                if (x.pid == yItem.id) {
                  testList.push({ source: yItem.id, target: x.id });
                }
              }
            }


          }
        }.bind(this));
      },

      // 计算最大值（替换箭头函数）
      moneyCalMax: function(arr) {
        var max = 0;
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item && item.value > max) {
            max = item.value;
          }
        }
        var result = Math.ceil(max / 9.5) * 10;
        return result || 100;
      },

      // 计算最小值（替换箭头函数）
      moneyCalMin: function(arr) {
        var min = 0;
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item && item.value < min) {
            min = item.value;
          }
        }
        var result = Math.floor(min / 10) * 10;
        return result || 0;
      },

      // 网络零售分析
      getTrendAnalysis: function() {
        if (!this.endTime || !this.userInfo.district) return;
        this.$http.get(this.header + '/trendDescription/list', {
          params: {
            times: this.endTime.replace(/-/g, ''),
            district: this.userInfo.district,
            desType: '网络零售',
            province: '江西省',
            city: '九江市'
          }
        }).then(function(res) {
          this.trendAnalysis = res.data.data || [];
        }.bind(this));
      },

      // 实物行业分析
      getIndustryAnalysis: function() {
        if (!this.endTime || !this.userInfo.district) return;
        this.$http.get(this.header + '/trendDescription/list', {
          params: {
            times: this.endTime.replace(/-/g, ''),
            district: this.userInfo.district,
            desType: '实物行业',
            province: '江西省',
            city: '九江市'
          }
        }).then(function(res) {
          this.industryAnalysis = res.data.data || [];
        }.bind(this));
      },

      // 默认月份
      oneMonth: function() {
        var dataArr = [];
        var data = new Date();
        var day = data.getDate();
        data.setMonth(data.getMonth() + 1, 1);
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1);
          var m = data.getMonth() + 1;
          m = m < 10 ? '0' + m : m;
          dataArr.push(data.getFullYear() + '-' + m);
        }
        this.endTime = day > 14 ? dataArr[1] : dataArr[2];
      }
    }
  }
</script>

<style>

  .area-index .ganPin-index-data .el-col {
    height: 100px;
    margin-right: 30px;
    background-color: #2A3039;
    width: 380px;
    padding: 20px;
    color: #A9B5C7;
    margin-bottom: 30px;
  }

  .area-index .area-index-header {
    text-align: left;
    margin-bottom: 20px;
    height: 45px;
    line-height: 45px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }
  .area-index .industryRank .el-card__header{
    padding: 18px 20px;
  }
  .area-index .industryRank .el-card__body{
    padding: 5px 20px;
  }
  .area-index .index-bg {
    background-size: 100% 100%;
    border-radius: 10px 10px 10px 10px;
    height: 110px;
    padding-top: 5px;
    width: 100%;
  }

  .area-index .area-index-header .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .otherClass {
    width: 7px;
    height: 7px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);

    background: linear-gradient(0deg, #5e64b2 0%, #c3c6f2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .numClass {
    color: white;
    margin-right: 5px;
    width: 53px;
    height: 86px;
    font-size: 66px;
    background: linear-gradient(0deg, #5e64b2, #c3c6f2);
    border-radius: 6px;
    display: inline-block;
  }

  .area-index .area-index-header .el-date-editor input {
    height: 30px;
    width: 130px;
    background-color: rgba(255, 255, 255, 1) !important;
    /*border-radius: 25px;*/
    color: #6B7991 !important;
  }

  .area-index .area-index-header .areaChoose input {
    background: rgba(36, 46, 71, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*width: 115px;*/
    height: 27px;
    line-height: 27px;
  }

  .area-index .area-total p {
    color: #333333;
    font-size: 14px;
    /*font-weight: bold;*/
  }

  .area-index .area-index-num {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    /*margin-top: 20px;*/
  }

  .area-index .index-span-box {
    width: 100%;
    margin-right: 20px;
    /*width: 100%;*/
    /*margin-top: -45px !important;*/
    background-size: 100% 100%;
    height: 55px;
  }

  .area-index .el-col-6 {
    /*border-left: 1px solid;*/
    border-image: linear-gradient(to bottom, #fff, #A8A8A8) 0.4 1;
    padding-left: 1%;
  }

  .ganPin-index .ganPin-index-data {
    overflow: hidden;
  }

  .ganPin-index .data-one {
    border: 2px solid #EC846B;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #EC846B;
    font-size: 28px;
  }

  .area-index .index-span-p {
    color: white;
    margin-top: 10px;
  }

  .area-index .index-span-yoy {
    color: white;
    font-size: 14px;
    margin-top: 10px;
  }

  .ganPin-index .data-two {
    border: 2px solid #E3B367;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #E3B367;
    font-size: 28px;
  }

  .ganPin-index .data-three {
    border: 2px solid #ABC471;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #ABC471;
    font-size: 28px;
  }

  .ganPin-index .data-four {
    border: 2px solid #60BDDF;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #60BDDF;
    font-size: 28px;
  }

  .area-index .index .topicOne {
    /*background: linear-gradient(225deg, rgba(255, 73, 65, 1), rgba(225, 7, 7, 1));*/
    background-color: #4270F2;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicTwo {
    background: cornflowerblue;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicThree {
    background: rgba(143, 176, 245, 1);
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .index .topicOther {
    /*background: linear-gradient(225deg, rgba(255, 165, 81, 1), rgba(255, 135, 16, 1));*/
    background-color: #8A8A8A;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

  .area-index .el-select .el-input__inner {
    width: 130px;
    height: 30px;
    color: #6B7991 !important;
  }

  .area-index .index-header-title {
    /*font-weight: bold;*/
    margin-bottom: 10px;
    margin-top: 10px;
    color: #313131;
    font-size: 18px;
  }
  .moneyContent {

    width: 755px;
    height: 95px;
    background: #EBEEF2;
    border-radius: 5px;
    margin: 5px 5px 5px 5px;
  }
  .moneyContents{
    padding: 10px;
    width: 755px;
    height: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #727171;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/area/CityIndex.vue